import {
  ADMIN,
  GEOSYNTEC,
  OWP,
  SWB,
  BABCOCK,
  DISTRICT_OFFICE,
  PWS,
  PWS_LOOKUP,
  REPORTS,
  WELLS_CONTACTS,
  WELL_LIST,
  PWS_CONTACTS_DETAILS,
  SCHEDULE_GOALS,
  SCHEDULE_SAMPLERS,
  WEEKLY_SAMPLE_KIT,
  PWS_BY_DISTRICT_OFFICES,
  VIDEOS,
  IMPORT_KITS,
  IMPORT_RESULTS,
  IMPORT_FIELD_DATA,
  FIELD_DATA_EDD,
} from "../constants/constant";

// VIKAS-- A list of all the roles that have access to all the tools.
export const ALL_ACCESS = [ADMIN];
// VIKAS-- A list of all the roles that are water systems.
export const WATER_SYSTEMS = [PWS];
// VIKAS-- A list of all the vendors that have access to the system.
export const VENDORS = [OWP, SWB, GEOSYNTEC, BABCOCK, DISTRICT_OFFICE];

/** VIKAS--
 * A mapping of tools to the vendors that have access to them.
 * Each tool is associated with an array of vendor constants
 * that represent the vendors with permissions to use the tool.
 */
export const TOOLS_TO_VENDOR_MAPPING = {
  PWS_LOOKUP: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC],
  REPORTS: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC, BABCOCK],
  WELLS_CONTACTS: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC],
  WELL_LIST: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC],
  PWS_CONTACTS_DETAILS: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC],
  SCHEDULE_GOALS: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC, BABCOCK],
  SCHEDULE_SAMPLERS: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC, BABCOCK],
  WEEKLY_SAMPLE_KIT: [...ALL_ACCESS, OWP, SWB, GEOSYNTEC, BABCOCK],
  PWS_BY_DISTRICT_OFFICES: [...ALL_ACCESS, OWP, SWB, DISTRICT_OFFICE],
  VIDEOS: [...ALL_ACCESS, OWP, GEOSYNTEC, SWB],
  IMPORT_KITS: [...ALL_ACCESS, OWP, GEOSYNTEC, SWB],
  IMPORT_RESULTS: [...ALL_ACCESS, OWP],
  IMPORT_FIELD_DATA: [...ALL_ACCESS, OWP, GEOSYNTEC],
  FIELD_DATA_EDD: [...ALL_ACCESS, OWP],
};

// VIKAS-- A list of all the tools that the ADMIN group has access to.
const ADMIN_TOOLS = [
  PWS_LOOKUP,
  REPORTS,
  WELLS_CONTACTS,
  WELL_LIST,
  PWS_CONTACTS_DETAILS,
  SCHEDULE_GOALS,
  SCHEDULE_SAMPLERS,
  WEEKLY_SAMPLE_KIT,
  PWS_BY_DISTRICT_OFFICES,
  VIDEOS,
  IMPORT_KITS,
  IMPORT_RESULTS,
  IMPORT_FIELD_DATA,
  FIELD_DATA_EDD,
];

// VIKAS-- A list of all the tools that the SWB vendor has access to.
const SWB_TOOLS = [
  PWS_LOOKUP,
  REPORTS,
  WELLS_CONTACTS,
  WELL_LIST,
  PWS_CONTACTS_DETAILS,
  SCHEDULE_GOALS,
  SCHEDULE_SAMPLERS,
  WEEKLY_SAMPLE_KIT,
  PWS_BY_DISTRICT_OFFICES,
  VIDEOS,
  IMPORT_KITS,
  FIELD_DATA_EDD
];

// VIKAS-- A list of all the tools that the GEOSYNTEC vendor has access to.
const GEOSYNTEC_TOOLS = [
  PWS_LOOKUP,
  REPORTS,
  WELLS_CONTACTS,
  WELL_LIST,
  PWS_CONTACTS_DETAILS,
  SCHEDULE_GOALS,
  SCHEDULE_SAMPLERS,
  WEEKLY_SAMPLE_KIT,
  VIDEOS,
  IMPORT_KITS,
  IMPORT_FIELD_DATA,
];

// VIKAS-- A list of all the tools that the BABCOCK vendor has access to.
const BABCOCK_TOOLS = [
  REPORTS,
  SCHEDULE_GOALS,
  SCHEDULE_SAMPLERS,
  WEEKLY_SAMPLE_KIT,
];

/** VIKAS--
 * A list of all the tools that the TESTER group has access to.
 * This is empty because the TESTER group is not actually a vendor
 * and should not have any access to the system.
 */
const TESTER_TOOLS = [];

// VIKAS-- A list of all the tools that the DISTRICT_OFFICE vendor has access to.
const DISTRICT_OFFICE_TOOLS = [PWS_BY_DISTRICT_OFFICES];

// VIKAS-- A mapping of vendors to the tools that they have access to.
export const VENDOR_TO_TOOLS_MAPPING = {
  OWP: ADMIN_TOOLS, // This group has all tools Access
  ADMIN: ADMIN_TOOLS, // This group has all tools Access
  TESTER: TESTER_TOOLS,
  SWB: SWB_TOOLS, // SWB: mapping for all the tools for this vendor defined above
  GEOSYNTEC: GEOSYNTEC_TOOLS, // GEOSYNTEC: mapping for all the tools for this vendor defined above
  BABCOCK: BABCOCK_TOOLS, // BABCOCK: mapping for all the tools for this vendor defined above
  DISTRICT_OFFICE: DISTRICT_OFFICE_TOOLS, // DISTRICT_OFFICE: mapping for all the tools for this vendor defined above
};

// VIKAS-- A list of all the roles that have read/write access across the water system heierarchy.
export const READ_WRITE_ACCESS = [
  ADMIN, // Admin has read/write access to all water systems
  OWP, // OWP has read/write access to all water systems
  GEOSYNTEC, // GEOSYNTEC has read/write access to all water systems
];
